import script from "./TopBar.vue?vue&type=script&setup=true&lang=js"
export * from "./TopBar.vue?vue&type=script&setup=true&lang=js"

import "./TopBar.vue?vue&type=style&index=0&id=11b2bd73&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11b2bd73"]])

export default __exports__